// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m91wug{overflow-y:auto}\n._19bvutpp{padding-left:var(--ds-space-150,9pt)}\n._1bsb1llu{width:152px}\n._1bsbn8ye{width:241px}\n._c71ldgin{max-height:500px}\n._ca0qutpp{padding-top:var(--ds-space-150,9pt)}\n._n3tdutpp{padding-bottom:var(--ds-space-150,9pt)}\n._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}\n._u5f3utpp{padding-right:var(--ds-space-150,9pt)}", ""]);
// Exports
module.exports = exports;
